<script>
  import { mdbBtn, mdbIcon, mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter } from 'mdbvue';
  import { deleteReport as apiDeleteReport } from '@/api/api'
  export default {
    created () {
      this.$parent.$on('showRemoveReportModalConfirm', this.showModal)
    },
    data: () => ({
      isModalVisible: false,
      reportId: null
    }),
    methods: {
      showModal ({ reportId }) {
        this.reportId = reportId
        this.isModalVisible = true
      },
      closeModal () {
        this.isModalVisible = false
      },
      onDeleteClick () {
        apiDeleteReport({ id: this.reportId }).then(() => {
          this.$snotify.success('', 'Raport został usunięty')
          this.$store.dispatch('reports/RETRIEVE_LIST')
          this.closeModal()
        }).catch(() => {
          this.$snotify.error('', 'Wystąpił błąd')
        })
      }
    },
    components: {
      mdbBtn,
      mdbIcon,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter
    }
  }
</script>

<template>
  <mdb-modal
    :show="isModalVisible"
    @close="closeModal"
    size="sm"
    class="text-center"
    danger
  >
    <mdb-modal-header center :close="false">
      <p class="heading">Czy chcesz usunąć wybrany raport?</p>
    </mdb-modal-header>
    <mdb-modal-body>
      <mdb-icon icon="times" size="4x" class="animated rotateIn" />
    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn color="danger" @click="onDeleteClick">Usuń</mdb-btn>
      <mdb-btn outline="danger" @click="closeModal">Anuluj</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

